import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    CardBody,
    Spinner
} from "reactstrap";
import Select from 'react-select'
import InputImage from '../../../components/Inputs/InputImage.jsx';

import L from 'leaflet';
import { Map, Marker, FeatureGroup } from 'react-leaflet'
import { point, polygon, booleanPointInPolygon } from '@turf/turf';
import { EditControl } from 'react-leaflet-draw';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';

// style
import "../../../assets/css/map.css";
import "../../../assets/css/loading.css";

// helpers
import { InputCEP } from "../../../helpers/mask.js";
import { formateDateApi } from "../../../helpers/formats.js";
import { icon_ecoponto_azul, icon_planotrabalho_azul, icon_avulso_azul, icon_ecoponto_cinza, icon_planotrabalho_cinza, icon_avulso_cinza } from "../../../helpers/icons";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_GETExternal, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

export default function PontosColetaForm({ history, item }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, clearErrors, setValue, getValues } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [mapaSatelite, setmapaSatelite] = useState(false);

    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
    const [modalidadesColeta, setModalidadesColeta] = useState([]);
    const loadOptionsModalidadesColeta = () => {
        api_GET(`modalidadeColeta`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }
    const handleModalidadesColeta = event => {
        let value = event;
        let lstSelect = [];
        value.map(item => {
            lstSelect.push({
                pontoColetaId: item == null ? null : item.pontoColetaId,
                modalidadeColetaId: item.modalidadeColetaId
            });
        });
        setModalidadesColeta(lstSelect);
        clearErrors("modalidadeColeta");
    }

    const options_frequencia = [
        { value: 'Diaria', label: 'Diária' },
        { value: 'Semanal', label: 'Semanal' },
        { value: 'Quinzenal', label: 'Quinzenal' },
        { value: 'Mensal', label: 'Mensal' },
        { value: 'Avulsa', label: 'Avulsa' }
    ];
    const [frequencia, setFrequencia] = useState("");
    const handleFrequencia = (value) => {
        clearErrors("frequencia");
        setFrequencia(value);
    }

    const options_dias_semana = [
        { value: "Segunda", label: "Segunda" },
        { value: "Terça", label: "Terça" },
        { value: "Quarta", label: "Quarta" },
        { value: "Quinta", label: "Quinta" },
        { value: "Sexta", label: "Sexta" },
        { value: "Sábado", label: "Sábado" },
        { value: "Domingo", label: "Domingo" }
    ]
    const [diasSemana, setDiasSemana] = useState([]);
    const handleDiasSemana = event => {
        let value = event;
        let lstSelect = [];
        value.map(item => {
            lstSelect.push(item.value);
        });
        setDiasSemana(lstSelect);
        clearErrors("dias_semana");
    }

    const [options_status, set_options_status] = useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" }
    ]);
    const [status, setStatus] = useState("Ativo");
    const handleStatus = (value) => {
        clearErrors("status");
        setStatus(value);
    }

    const options_categoria = [
        { value: "Plano de Trabalho", label: "Plano de Trabalho" },
        { value: "Avulso", label: "Avulso" },
        { value: "Ecoponto", label: "Ecoponto" },
    ]
    const [categoria, setCategoria] = useState("");
    const handleCategoria = (value) => {
        clearErrors("categoria");
        setCategoria(value);
    }

    const [territorio, setTerritorio] = useState(null);
    const [positionEndereco, setPositionEndereco] = useState([-3.755019499914185, -38.5860013961792]);
    const [center, setCenter] = useState([-3.755019499914185, -38.5860013961792]);
    const [cep, setCep] = useState("");
    const handleCEP = (event) => {
        clearErrors("cep");
        setCep(event.target.value.replace("-", ""));
        setTerritorio(null);

        if (event.target.value.length != 9)
            return;

        setshowLoading(true);
        api_GETExternal(`https://viacep.com.br/ws/${event.target.value.replace("-", "")}/json/`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
            }
            else {
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);
                let chave = "";
                if (result.data.logradouro != null)
                    chave = result.data.logradouro.replaceAll(" ", "+") + "," + result.data.bairro.replaceAll(" ", "+") + result.data.localidade.replaceAll(" ", "+");
                UpdatePositionEndereco(chave);
            }
        });
    }
    const handleEnderecoChange = (event) => {
        let data = getValues();
        let numero = data.numero == null ? "" : data.numero;
        let logradouro = data.logradouro == null ? "" : data.logradouro.replaceAll(" ", "+");
        let bairro = data.bairro == null ? "" : data.bairro.replaceAll(" ", "+");
        let cidade = data.cidade == null ? "" : data.cidade.replaceAll(" ", "+");
        if (bairro != "" && logradouro != "" && cidade != "") {
            let chave = logradouro + "," + numero + "," + bairro + cidade;
            UpdatePositionEndereco(chave);
        }
    }

    const UpdatePositionEndereco = (chave) => {
        setshowLoading(true);
        api_POST(`GeoCoding/GetPositionEndereco`, chave).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
            }
            else {
                try {
                    setCenter([result?.data?.latitude?.replace(",", "."), result?.data?.longitude?.replace(",", ".")]);
                    setPositionEndereco([result?.data?.latitude?.replace(",", "."), result?.data?.longitude?.replace(",", ".")]);
                }
                catch {
                    showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
                }
            }
        });
    }

    const handleMarkerPosition = event => {
        setPositionEndereco([event.target.getLatLng().lat, event.target.getLatLng().lng]);
    }
    const AnaliseTerritorioEndereco = () => {
        setTerritorio(null);
        setValue("territorio", "");
        setValue("regional", "");
        if (positionEndereco == null)
            return;

        var lista = JSON.parse(localStorage.getItem("territorios"))
        var turf_point = point([positionEndereco[1], positionEndereco[0]]);
        for (var t in lista) {
            var item = lista[t];
            var geojson = JSON.parse(item.geoJson);
            if (geojson.features == null)
                geojson.features = [geojson];
            for (var b in geojson.features) {
                var feature = geojson.features[b];
                if (feature.geometry.type == "Polygon") {
                    var turf_polygon = polygon(feature.geometry.coordinates);

                    if (booleanPointInPolygon(turf_point, turf_polygon)) {
                        setTerritorio(item);
                        setValue("territorio", item.descricao);

                        api_GET(`regional/${item.regionalId}`).then(result => {
                            if (result.status !== 200) {
                                showMessage("Não foi possível consultar a regional", result.message, 'error', null);
                            }
                            else {
                                setValue("regional", result.data.descricao);
                            }
                        });

                        return;
                    }
                }
            }
        }
    }
    useEffect(() => {
        AnaliseTerritorioEndereco();
    }, [positionEndereco]);

    const [showPontosCadastrados, setShowPontosCadastrados] = useState(false);
    const [listPontosCadastrados, setlistPontosCadastrados] = useState(null);
    const handlePontosCadastrados = event => {
        setShowPontosCadastrados(event.target.checked);
    }
    const loadPontosCadastrados = () => {
        api_GET(`pontocoleta`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setlistPontosCadastrados(result.data);
            }
        });
    }
    useEffect(() => {
        loadPontosCadastrados();
    }, [showPontosCadastrados])

    const [imagemPontoColeta, setImagemPontoColeta] = useState(null);
    const handleImage = (newimage, oldimage) => {
        setImagemPontoColeta(newimage);
    }

    const GetListTerritorios = (callback) => {
        if (localStorage.getItem("territorios") == null) {
            setshowLoading(true);
            api_GET('territorio/GetWithGeoJson').then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Não foi possível carregar a lista de áreas operacionais", result.message, 'error', null);
                    callback();
                }
                else {
                    localStorage.setItem("territorios", JSON.stringify(result.data));
                    callback();
                }
            });
        }
        else
            callback();
    }

    /**** Draw ****/
    const [_editableFG, set_editableFG] = useState(null); // Elemento que armazena o FeatureGroup (desenhos)    
    const _onFeatureGroupReady = (reactFGref) => { // Função que registra o feature group no elemento acima
        set_editableFG(reactFGref);
    }

    const onSubmit = (data) => {
        if (modalidadesColeta.length == 0) {
            setError("modalidadeColeta");
            return;
        }

        if (categoria == "") {
            setError("categoria");
            return;
        }

        if (status == "") {
            setError("status");
            return;
        }

        if (frequencia == "") {
            setError("frequencia");
            return;
        }

        if (territorio == null) {
            showMessage("Aviso", "O endereço informado não pertence a uma área operacional e não pode ser cadastrado!", 'warning', null);
            return;
        }

        let calendario = "";
        if (frequencia == "Semanal" && diasSemana.length > 0) {
            for (var i in diasSemana)
                calendario += diasSemana[i] + "|";
        }

        let values = getValues();

        let json_submit = {
            pontoColetaId: item == null ? 0 : item.pontoColetaId,
            identificacao: categoria == "Ecoponto" ? data.identificacao : "",
            cep: cep,
            logradouro: values.logradouro,
            numeroLogradouro: values.numero,
            complemento: values.complemento,
            bairro: values.bairro,
            cidade: values.cidade,
            uf: values.uf,
            latitude: positionEndereco[0],
            longitude: positionEndereco[1],
            GeoJson: (_editableFG != null && _editableFG.leafletElement != null) ? JSON.stringify(_editableFG.leafletElement.toGeoJSON()) : "",
            tipo: "Ponto",
            categoria: categoria,
            territorioId: territorio.territorioId,
            delimitacaoGeograficaSetorId: null,
            status: status,
            frequencia: frequencia,
            calendario: calendario,
            dataProximaColeta: data.data_proxima_coleta != null ? formateDateApi(data.data_proxima_coleta) : null,
            pontoColetaModalidadeColetas: modalidadesColeta,
            cadastroAutomaticoSistema: false,
            imagemCadastro: imagemPontoColeta == null ? "" : imagemPontoColeta.name,
            imageBase64: imagemPontoColeta == null ? "" : imagemPontoColeta.base64,
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId
        }

        setshowLoading(true);
        if (json_submit.pontoColetaId == 0) {
            api_POST('pontoColeta', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        window.location.reload()
                    });
                }
            });
        }
        else {
            api_PUT('pontoColeta', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        window.location.reload()
                    });
                }
            });
        }
    };

    const [disableAll, setdisableAll] = useState(false);
    useEffect(() => {
        GetListTerritorios(function () {
            loadOptionsModalidadesColeta();
            if (item != null) {
                
                setValue("cep", item.cep);
                setCep(item.cep);
                setValue("logradouro", item.logradouro);
                setValue("numero", item.numeroLogradouro);
                setValue("complemento", item.complemento);
                setValue("bairro", item.bairro);
                setValue("cidade", item.cidade);
                setValue("uf", item.uf);
                setTerritorio(null);
                setCategoria(item.categoria);
                setStatus(item.status);
                setFrequencia(item.frequencia);

                setModalidadesColeta(item.pontoColetaModalidadeColetas);

                if (item.imagemCadastro != null && item.imagemCadastro != "")
                    setImagemPontoColeta({ name: item.imagemCadastro, base64: null });

                setPositionEndereco([item.latitude, item.longitude]);
                setCenter([item.latitude, item.longitude]);
                setTimeout(function () {
                    if (item.dataProximaColeta != null)
                        setValue("data_proxima_coleta", formateDateApi(item.dataProximaColeta));
                }, 0.5)

                let calendario = [];
                if (item.calendario != "") {
                    let _calend = item.calendario.split("|");
                    for (var i in _calend) {
                        if (_calend[i] != "")
                            calendario.push(_calend[i]);
                    }
                    setDiasSemana(calendario);
                }

                if (item.geoJson != "") {
                    let leafletGeoJSON = new L.GeoJSON(JSON.parse(item.geoJson));
                    let leafletFG = _editableFG.leafletElement;
                    leafletGeoJSON.eachLayer((layer) => {
                        leafletFG.addLayer(layer);
                    });
                }
                if (item.categoria == "Ecoponto")
                    setValue("identificacao", item.identificacao);
            }
        });
    }, [item]);

    return (
        <>
            <div>
                {showLoading &&
                    <div className="carregandoCmp">
                        <div className="box">
                            <label style={{ marginRight: "20px" }}>Carregando...</label>
                            <Spinner size="sm" color="info" />
                        </div>
                    </div>
                }
                <Row>
                    <Container fluid>
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <strong> Local de Execução</strong>
                            </CardHeader>
                            <CardBody>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col md="6" lg="4">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Categoria
                                                </label>
                                                <Select
                                                    name="categoria"
                                                    options={options_categoria}
                                                    onChange={(e) => handleCategoria(e.value)}
                                                    value={options_categoria.find(obj => obj.value === categoria)}
                                                    placeholder="Selecione"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.categoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" lg="4" className={categoria != "Ecoponto" && "d-none"}>
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Identificação
                                                </label>
                                                <Input
                                                    name="identificacao"
                                                    placeholder="Identificação"
                                                    type="text"
                                                    innerRef={register({ required: categoria == "Ecoponto" ? true : false })}
                                                />
                                                {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="4" lg="2">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * CEP
                                                </label>
                                                <InputCEP
                                                    name="cep"
                                                    placeholder="Cep"
                                                    value={cep}
                                                    onChange={handleCEP}
                                                    inputRef={register({ required: false })}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="8" lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Logradouro
                                                </label>
                                                <Input
                                                    name="logradouro"
                                                    placeholder="Logradouro"
                                                    type="text"
                                                    disabled={disableAll ? "disabled" : ""}
                                                    innerRef={register({ required: true })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="2">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Número
                                                </label>
                                                <Input
                                                    name="numero"
                                                    placeholder="Número"
                                                    type="number"
                                                    onBlur={handleEnderecoChange}
                                                    innerRef={register({ required: true })}
                                                    disabled={disableAll ? "disabled" : ""}

                                                />
                                                {errors.numero && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="2">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Complemento
                                                </label>
                                                <Input
                                                    name="complemento"
                                                    placeholder="Complemento"
                                                    type="text"
                                                    maxLength={30}
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="5">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Bairro
                                                </label>
                                                <Input
                                                    name="bairro"
                                                    placeholder="Bairro"
                                                    type="text"
                                                    onBlur={handleEnderecoChange}
                                                    disabled={disableAll ? "disabled" : ""}
                                                    maxLength={200}
                                                    innerRef={register({ required: true })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="5">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Cidade
                                                </label>
                                                <Input
                                                    name="cidade"
                                                    placeholder="cidade"
                                                    type="text"
                                                    onBlur={handleEnderecoChange}
                                                    disabled={disableAll ? "disabled" : ""}
                                                    maxLength={200}
                                                    innerRef={register({ required: true })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * UF
                                                </label>
                                                <Input
                                                    name="uf"
                                                    placeholder="uf"
                                                    type="text"
                                                    disabled={disableAll ? "disabled" : ""}
                                                    maxLength={2}
                                                    innerRef={register({ required: true })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" lg="3">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Divisão Administrativa
                                                </label>
                                                <Input
                                                    name="regional"
                                                    placeholder="Divisão Administrativa"
                                                    type="text"
                                                    disabled="disabled"
                                                    innerRef={register()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" lg="3">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Área Operacional
                                                </label>
                                                <Input
                                                    name="territorio"
                                                    placeholder="Área Operacional"
                                                    type="text"
                                                    disabled="disabled"
                                                    innerRef={register()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Modalidade de Serviço
                                                </label>
                                                <Select
                                                    options={optionsModalidadesColeta}
                                                    name="modalidadeColeta"
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                    onChange={(value) => { handleModalidadesColeta(value || []) }}
                                                    value={modalidadesColeta != null && optionsModalidadesColeta.filter(({ modalidadeColetaId }) => modalidadesColeta.filter(f => f.modalidadeColetaId == modalidadeColetaId).length > 0)}
                                                    placeholder="Selecione"
                                                    isMulti="true"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" lg="4">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Status
                                                </label>
                                                <Select
                                                    name="status"
                                                    options={options_status}
                                                    onChange={(e) => { handleStatus(e.value) }}
                                                    value={options_status.find(obj => obj.value === status)}
                                                    placeholder="Selecione"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" lg="4">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Frequência
                                                </label>
                                                <Select
                                                    name="frequencia"
                                                    options={options_frequencia}
                                                    onChange={(e) => handleFrequencia(e.value)}
                                                    value={options_frequencia.find(obj => obj.value === frequencia)}
                                                    placeholder="Selecione"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.frequencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        {frequencia == "Semanal" &&
                                            <Col md="12" lg="12">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-address" >
                                                        * Dias da Semana
                                                    </label>
                                                    <Select
                                                        options={options_dias_semana}
                                                        name="dias_semana"
                                                        onChange={(value) => { handleDiasSemana(value || []) }}
                                                        value={options_dias_semana.filter(({ value }) => diasSemana.indexOf(value) != -1)}
                                                        placeholder="Selecione"
                                                        isMulti="true"
                                                        isDisabled={disableAll ? "yes" : ""}
                                                    />
                                                    {errors.dias_semana && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                        }
                                        {(frequencia == "Quinzenal" || frequencia == "Mensal") &&
                                            <Col md="6" lg="4">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-address" >
                                                        * Data da Próxima Coleta
                                                    </label>
                                                    <Input
                                                        innerRef={register({ required: true })}
                                                        defaultValue=""
                                                        name="data_proxima_coleta"
                                                        placeholder="Próxima Coleta"
                                                        type="date"
                                                        disabled={disableAll ? "disabled" : ""}
                                                    />
                                                    {errors.data_proxima_coleta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                        }
                                    </Row>
                                    <Row>
                                        <Col md="12">
                                            <label className="form-control-label">
                                                Imagem do Local de Execução
                                            </label>
                                        </Col>
                                        <Col md="4" lg="4" xl="2">
                                            <InputImage name="file1" image={imagemPontoColeta} uploadImage={handleImage}></InputImage>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12">
                                            <h4>Confirme no mapa a geolocalização do endereço</h4>
                                        </Col>
                                        <Col md="12">
                                            <div id="map">
                                                <Map center={center} zoom={13} style={{ zIndex: "0" }}>
                                                    {mapaSatelite &&
                                                        <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }} type={'satellite'} />
                                                    }
                                                    {!mapaSatelite &&
                                                        <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }} type={'roadmap'} />
                                                    }

                                                    <Marker position={positionEndereco} draggable={true} icon={categoria == "Ecoponto" ? icon_ecoponto_azul : (categoria == "Plano de Trabalho" ? icon_planotrabalho_azul : icon_avulso_azul)} onDragend={handleMarkerPosition}></Marker>

                                                    {(showPontosCadastrados && listPontosCadastrados != null) && listPontosCadastrados.filter(f => f.latitude != positionEndereco[0] && f.longitude != positionEndereco[1]).map(item => (
                                                        <Marker position={[item.latitude, item.longitude]} draggable={false} icon={item.categoria == "Ecoponto" ? icon_ecoponto_cinza : (item.categoria == "Plano de Trabalho" ? icon_planotrabalho_cinza : icon_avulso_cinza)}></Marker>
                                                    ))}

                                                    <FeatureGroup ref={(reactFGref) => { _onFeatureGroupReady(reactFGref); }}>
                                                        <EditControl
                                                            position='topright'
                                                            draw={{
                                                                rectangle: false,
                                                                polygon: false,
                                                                circle: false,
                                                                marker: false,
                                                                circlemarker: false
                                                            }}
                                                        />
                                                    </FeatureGroup>

                                                </Map>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md="12 text-right">
                                            <Button color="info" outline className="btn-sm" type="button" onClick={() => setmapaSatelite(!mapaSatelite)}>{mapaSatelite ? "Mapa" : "Satélite"}</Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="12" lg="12">
                                            <FormGroup check>
                                                <label check className="form-control-label">
                                                    <Input
                                                        name="pontos_cadastrados"
                                                        type="checkbox"
                                                        onChange={handlePontosCadastrados}
                                                        innerRef={register()}
                                                        disabled={disableAll ? "disabled" : ""}
                                                    />
                                                    Visualizar Locais Cadastrados
                                                </label>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12" className="text-center">
                                            <label className="form-control-label"></label>
                                            <FormGroup>
                                                <Button color="warning" type="button" onClick={() => { window.location.reload() }}>Voltar</Button>
                                                {!disableAll && <Button color="success">Salvar</Button>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Container>
                </Row>
            </div>
        </>
    );
}
